import _ from 'lodash';

function Div(cssClass, fields) {
    let fieldsArray = _.castArray(fields);
    return {
        wrapper: 'div',
        templateOptions: {
            className: cssClass
        },
        fieldGroup: fieldsArray || []
    };
}

function Fieldset(legend, fields) {
    let fieldsArray = _.castArray(fields);
    return {
        wrapper: 'fieldset',
        templateOptions: {
            label: legend,
        },
        fieldGroup: fieldsArray || []
    };
}



function Row(columns) {
    return Div('row', columns);
}



const Column2 = _.partial(Div, 'col-lg-2');
const Column3 = _.partial(Div, 'col-lg-3');
const Column4 = _.partial(Div, 'col-lg-4');
const Column5 = _.partial(Div, 'col-lg-5');
const Column6 = _.partial(Div, 'col-lg-6');
const Column7 = _.partial(Div, 'col-lg-7');
const Column8 = _.partial(Div, 'col-lg-8');
const Column9 = _.partial(Div, 'col-lg-9');
const Column10 = _.partial(Div, 'col-lg-10');
const Column11 = _.partial(Div, 'col-lg-11');
const Column12 = _.partial(Div, 'col-lg-12');

export {Div};
export {Row};
export {Fieldset};
export {Column2};
export {Column3};
export {Column4};
export {Column5};
export {Column6};
export {Column7};
export {Column8};
export {Column9};
export {Column10};
export {Column11};
export {Column12};



// WEBPACK FOOTER //
// ./app/components/common/forms/layout.js